// extracted by mini-css-extract-plugin
module.exports = {"productsDropdown":"ProductSelect-productsDropdown-2pFhzD"};